import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const paragraphs = [
  {
    text: 'Hugという名前には\n「抱きしめる」「つながる」という意味を込めました。',
  },
  {
    text: '人は一人では生きていけません。\n誰かとつながり、支え合いながら生きています。',
  },
  {
    text: '小さな命の存在は\n決して忘れてはいけない大切なものです。',
  },
  {
    text: 'Hugは\n人と人、命と命をつなぐ会社として\nやさしさのある社会を\n少しずつ広げていきたいと考えています。',
    highlight: true,
  },
];

export default function CEOMessageSection() {
  const { ref: headerRef, isVisible: headerVisible } = useScrollAnimation();
  const { ref: contentRef, isVisible: contentVisible } = useScrollAnimation(0.1);

  return (
    <section id="ceo-message" className="relative py-32 px-6 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/1d1cb259855ec1788168d98883e3a643.jpg"
          alt=""
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-[#F9F4EE]/90" />
      </div>

      <div className="relative z-10 max-w-3xl mx-auto">
        <div
          ref={headerRef}
          className={`text-center mb-16 fade-in ${headerVisible ? 'visible' : ''}`}
        >
          <p className="text-[#C97B7B] text-xs tracking-[0.4em] mb-4 uppercase">Message</p>
          <h2
            className="text-[#3A2E28] text-3xl md:text-4xl font-light mb-4"
            style={{ fontFamily: 'Noto Serif JP, serif' }}
          >
            代表メッセージ
          </h2>
          <div className="w-12 h-px bg-[#C8B99A] mx-auto" />
        </div>

        <div
          ref={contentRef}
          className={`fade-in ${contentVisible ? 'visible' : ''}`}
        >
          <div className="flex justify-center mb-10">
            <i className="ri-double-quotes-l text-6xl" style={{ color: '#C8B99A' }} />
          </div>

          <div className="flex flex-col gap-8 mb-12">
            {paragraphs.map((p, i) => (
              <p
                key={i}
                className={`text-center text-base md:text-lg leading-loose whitespace-pre-line ${
                  p.highlight
                    ? 'text-[#A8835A] font-medium'
                    : 'text-[#3A2E28]'
                }`}
                style={{ fontFamily: 'Noto Serif JP, serif' }}
              >
                {p.text}
              </p>
            ))}
          </div>

          <div className="flex flex-col items-center gap-3 pt-10 border-t border-[#D8C8B0]">
            <div className="w-8 h-px bg-[#C8B99A]" />
            <p className="text-xs tracking-[0.3em] text-[#A8835A]">代表</p>
            <p
              className="text-base font-medium text-[#3A2E28]"
              style={{ fontFamily: 'Noto Serif JP, serif' }}
            >
              金谷千紘
            </p>
            <p className="text-xs text-[#A8835A] tracking-wider">Hug</p>
          </div>
        </div>
      </div>
    </section>
  );
}
